document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.js-header');
  const headerFixed = document.querySelector('.js-header-fixed');
  const kv = document.querySelector('.js-kv');
  let isTicking = false;
  
  window.addEventListener('scroll', () => {
    if (!isTicking) {
      window.requestAnimationFrame(() => {
        const kvBottom = kv.offsetTop + kv.offsetHeight;
        const scrollPosition = window.scrollY || window.pageYOffset;
  
        if (scrollPosition > kvBottom) {
          headerFixed.classList.add('is-fixed');
        } else {
          headerFixed.classList.remove('is-fixed');
        }
  
        isTicking = false;
      });
  
      isTicking = true;
    }
  });
});